const Label = ({ text, colon = true, className }) => {
  return (
    <div className={`ant-form-item-label ${className}`}>
      <label>
        {text} {colon && ':'}
      </label>
    </div>
  )
}

export default Label
